import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { AddonInputDto, AddonService, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-add-extra',
  templateUrl: './add-extra.component.html',
  styleUrls: ['./add-extra.component.css']
})

export class AddExtraComponent implements OnInit {

  addExtraForm: FormGroup = this.fb.group({
    name: ['', Validators.compose([Validators.required,Validators.pattern('[A-Z][a-z ]*'), WhiteSpaceValidator.cannotContainSpace])],
    price: ['', Validators.compose([Validators.required, Validators.min(1)])]
  })

  constructor(
    private fb: FormBuilder,
    private addonService: AddonService,
    private authService: AuthService,
    private router: Router,
    private snackBar: SnackBarService
  ) { }

  storeResponse: StoreResponseDto = {} as StoreResponseDto;
  addonInput: AddonInputDto = {} as AddonInputDto;

  ngOnInit(): void {
    this.storeResponse = this.authService.currentUserStore();
  }

  saveChanges(form: any) {

    this.addonInput = { dsName: form.name, qtPrice: form.price, cdStore: Number(this.storeResponse.cdStore) }

    this.addonService.apiAddonPostPost(this.addonInput).subscribe(response => {

      this.router.navigate(['additionals']);
      this.snackBar.openSnackBar('Los cambios se guardaron correctamente','Aceptar')
    },
      (err) => {
        this.snackBar.openSnackBar(err.error.error, 'Aceptar')
      }
    )
  }
}
